import AuthGuard from "components/auth/AuthGuard";
import MobileDeviceCheck from "components/mobile/MobileDeviceCheck";
import React from "react";

const EmptyLayout = (p: { children: React.ReactNode }) => {
  return (
    <AuthGuard>
      <MobileDeviceCheck>{p.children}</MobileDeviceCheck>
    </AuthGuard>
  );
};

export default EmptyLayout;
